var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M48.9805 31.8582C49.1572 31.4849 49.9999 29.4704 49.9999 29.4704C49.9999 29.4704 48.0381 30.3748 47.6651 30.5516C45.2011 31.7305 42.5506 32.3297 39.7823 32.3297C29.6318 32.3297 21.3761 24.0682 21.3761 13.9109C21.3761 11.1604 21.9749 8.50804 23.1431 6.03253C23.3197 5.65924 24.0743 3.96997 24.0743 3.96997C24.0743 3.96997 22.2105 4.5492 21.8277 4.72601C14.7597 8.07581 10.1851 15.2959 10.1851 23.135C10.1851 25.1997 10.4936 27.1938 11.0668 29.0734C12.5242 28.5994 14.0952 28.5784 15.5941 29.0268C17.5842 29.6233 19.2097 30.9994 20.138 32.7921L20.2286 32.974L20.4833 32.9796C21.0155 33.0009 21.5467 33.0794 22.0693 33.2143L22.3819 33.3021C26.2348 34.4635 28.4855 38.4244 27.5775 42.2882L27.5286 42.4814L27.5286 43.294C28.5161 43.4419 29.5266 43.5185 30.5546 43.5185C38.3982 43.5185 45.6232 38.9408 48.9805 31.8582Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.8474 35.075C20.9032 34.7885 19.9239 34.7476 18.9797 34.9581C18.5164 32.9875 17.0328 31.3912 15.0624 30.8006C13.5963 30.362 12.0422 30.5141 10.6935 31.2391C9.34469 31.9583 8.35949 33.1629 7.91967 34.6189C7.86104 34.806 7.81412 34.9931 7.77306 35.1861C4.91129 34.6189 2.02607 36.3029 1.164 39.1448C1.12294 39.2968 1.08193 39.443 1.04671 39.595C0.700733 41.1855 1.10537 42.8462 2.15506 44.1385C3.26342 45.5126 4.91129 46.2962 6.67057 46.2962H20.0294C22.598 46.2962 24.9144 44.6413 25.6591 42.2732C25.665 42.2614 25.6709 42.2439 25.6709 42.2381L25.1196 42.0392L25.6767 42.2322C25.6767 42.2205 25.6767 42.2147 25.6826 42.2088C26.5916 39.1857 24.8733 35.9872 21.8474 35.075Z",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.48910b97e8f136b69c7103e3884a7921.svg";
export { ForwardRef as ReactComponent };